import { render, staticRenderFns } from "./ProjectsPeriodReportCard.vue?vue&type=template&id=5db92a84&scoped=true&"
import script from "./ProjectsPeriodReportCard.vue?vue&type=script&lang=js&"
export * from "./ProjectsPeriodReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPeriodReportCard.vue?vue&type=style&index=0&id=5db92a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db92a84",
  null
  
)

export default component.exports